export function extractLoginErrorEmail(data: unknown): string | null {
  if (data == null || typeof data !== 'object' || !('email' in data)) {
    return null;
  }

  const email = (data as { email?: unknown }).email;
  if (typeof email !== 'string') {
    return null;
  }

  const trimmed = email.trim();
  return trimmed.length > 0 ? trimmed : null;
}
